import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  @Input() itemName: string = ''; // Pass the item's name to the dialog
  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();

  confirmDelete() {
    this.onConfirm.emit(); // Emit confirmation event
  }
}
